import React from "react";
import {Col, Offcanvas, Row} from "react-bootstrap";
import {connect, ConnectedProps} from "react-redux";
import {useLocation} from "react-router-dom";
import {GeneralActions} from "../../store/actions/GeneralActions";
import StateType from "../../store/store";
import NavigationItem from "./NavigationItem/NavigationItem";

import * as config from "../../config";
import {Func} from "../../types";
import {ExpertTerm, ReferralTerm} from "../BrandingEngine/BrandingTerm/BrandingTerms";
import styles from "./Navigation.module.scss"
import { useCookies } from "react-cookie";

export type NavItem = {
    title: React.ReactNode;
    path: string;
    is_active?: Func<[string], boolean>;
    display_link?: Func<[string], boolean>;
}

const AdminSettingsNav: NavItem[] = [
    {title: 'Send Consent Form', path: '/reguser'},
    {title: 'Consent Form History', path: '/reguser/review_consent'},
    {title: 'Profile Information', path: '/reguser/profile_information'},
    {title: 'Manage Plan', path: '/reguser/billing'},
    {title: 'Contacts', path: '/reguser/contacts'},
    {title: 'Templates', path: '/reguser/templates'},
    {title: 'Users', path: '/reguser/users'},
];

// const RegUserNav: NavItem[] = [
//     {title: 'Send Consent Form', path: '/reguser'},
//     {title: 'Review Consent Form', path: '/reguser/review_consent'},
// ]

const EmployeeNav: NavItem[] = [
    {title: 'Accounts', path: '/employee'},
];

const RegUserNav: NavItem[] = [
    {title: 'Send Consent Form', path: '/reguser'},
    {title: 'Consent Form History', path: '/reguser/review_consent'},
    {title: 'Profile Information', path: '/reguser/profile_information'},
    {title: 'Contacts', path: '/reguser/contacts'},
    {title: 'Templates', path: '/reguser/templates'},
];

const map_state_to_props = (state: StateType) => ({
    state: {
        show_mobile_nav: state.general.show_mobile_nav,
        user_email: state.account.user_data?.email,
        roles: state.account.user_data?.roles,
        user_data: state.account.user_data,
        employee_is_managing: state.employee.employee_is_managing,
        is_employee: state.account.is_employee
    }
});

const map_dispatch_to_props = (dispatch: any) => ({
    actions: {
        hide_mobile_nav: () => dispatch(GeneralActions.hide_mobile_nav())
    }
});

const connector = connect(map_state_to_props, map_dispatch_to_props);

const Navigation = ({state, actions}: ConnectedProps<typeof connector>) => {
    const [cookies] = useCookies();
    const is_initial_login = cookies[config.INITIAL_LOGIN_TOKEN_COOKIE_NAME];
    const is_manage_user = cookies[config.MANAGE_USER_TOKEN_COOKIE_NAME];
    const location = useLocation();
    const nav_items = (() : NavItem[] => {
        if (!state.roles) return [];
        if (state.roles.find(role => role.toLowerCase() === 'employee')) {
            if ((state.employee_is_managing || is_manage_user) && state.roles.find(role => role.toLowerCase() === 'admin')){
                return [...EmployeeNav, 
                    {title: <div className={`${styles.RouteIndent}`}>Consent Form History</div>, path: '/employee/reguser/review_consent'},
                    {title: <div className={`${styles.RouteIndent}`}>Contacts</div>, path: '/employee/reguser/contacts'},
                    {title: <div className={`${styles.RouteIndent}`}>Templates</div>, path: '/employee/reguser/templates'},
                    {title: <div className={`${styles.RouteIndent}`}>Users</div>, path: '/employee/reguser/users'},];
            } 
            else if ((state.employee_is_managing || is_manage_user) && state.roles.find(role => role.toLowerCase() !== 'admin')){
                return [...EmployeeNav, 
                    {title: <div className={`${styles.RouteIndent}`}>Consent Form History</div>, path: '/employee/reguser/review_consent'},
                    {title: <div className={`${styles.RouteIndent}`}>Contacts</div>, path: '/employee/reguser/contacts'},
                    {title: <div className={`${styles.RouteIndent}`}>Templates</div>, path: '/employee/reguser/templates'},];
            } 
            else {
                return [...EmployeeNav];
            }
        }
        if (state.roles.find(role => role.toLowerCase() === 'reguser')) {
            if (state.roles.find(role => role.toLowerCase() === 'admin')) return [...AdminSettingsNav];
            return [...RegUserNav];
        }
        return [];
    })();
    const render_nav_items = () => nav_items.filter(nav_item => nav_item.display_link ? nav_item.display_link(state.user_email || '') : true)
        .map((nav_item, index) => <NavigationItem nav_item={nav_item} key={index}/>);
    const hidden_nav_paths = [
        '/expired',
        '/association',
        '/add-client',
        '/manage-clients/update-terms',
        '/manage-clients/update-header',
        '/manage-clients/update-footer',
        '/manage-clients/update-carrier-icon',
        '/select_profile',
        '/manage-clients/update-referral-bulk-upload',
        '/404',
    ];
    
    const nav_path_show = [
        '/settings',
    ]

    if (hidden_nav_paths.findIndex(path => location.pathname.indexOf(path) >= 0) >= 0) return null;
    if (is_initial_login === 'true' && !state.is_employee) return null;
    // if (nav_path_show.findIndex(path => location.pathname.indexOf(path) >= 0) >= 0) 
    return (
        <>
            <Col className={`d-none d-xl-block ${styles.NavigationPane}`} xl={2}>
                <Row className={`${styles.NavigationMargin}`}>
                    <Col className="d-grid gap-2 mt-5 ms-auto me-auto" xl={12}>
                        {render_nav_items()}
                    </Col>
                </Row>
            </Col>
            <Offcanvas className={'d-xl-none'} show={state.show_mobile_nav} onHide={actions.hide_mobile_nav}
                       backdrop={false}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{/*Blank title for close button positioning*/}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className={'d-grid gap-2'}>
                        {render_nav_items()}
                        <NavigationItem nav_item={{path: '/logout', title: 'Log Out'}}/>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )

    
};

export default connector(Navigation);
